export default "__VITE_ASSET___5GvFx3a__"